import { CreateActionBulkModalButton } from '@aibees/elephant/components/create-action-bulk-modal-button';
import { LabelsList } from '@aibees/elephant/components/labels-list/labels-list';
import { LabelType } from '@aibees/elephant/types/label';
import { OutlinedInput } from '@aibees/shared/components';
import { Stack } from '@mui/material';
import { memo, useMemo, useState } from 'react';
import { LabelManagementProvider } from '../../context';
import { config } from './config';
import type { LabelManagementProps as Props } from './types';

let { defaultValues } = config;

export const LabelManagement = memo(
  ({
    className: _className,
    type,
    setItems,
    onOpenDialog,
    searchType,
    placeholder,
    hasCreateButton = true,
    overrideLabels,
  }: Props) => {
    defaultValues ||= {};

    const isLabel = useMemo(() => type === LabelType.LABEL, [type]);
    const computedPlaceholder = useMemo(
      () =>
        placeholder ??
        (isLabel
          ? 'Search or select from existing labels…'
          : 'Search or select from existing lists…'),
      [placeholder, isLabel]
    );

    const [searchValue, setSearchValue] = useState('');

    const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchValue(e.target.value);
    };

    return (
      <LabelManagementProvider
        onChangeLabels={setItems}
        type={type}
        overrideLabels={overrideLabels}
      >
        <Stack
          direction="column"
          alignItems="flex-start"
          gap={0.5}
          width="100%"
        >
          <Stack direction="row" gap={0.5} alignItems="center" width="100%">
            <OutlinedInput
              name="search"
              size="small"
              fullWidth
              placeholder={computedPlaceholder}
              value={searchValue}
              onChange={handleChangeSearch}
            />

            {hasCreateButton && (
              <CreateActionBulkModalButton onClick={onOpenDialog} />
            )}
          </Stack>

          <LabelsList
            type={type}
            searchType={searchType}
            searchValue={searchValue}
          />
        </Stack>
      </LabelManagementProvider>
    );
  }
);

LabelManagement.displayName = 'LabelManagement';
